import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import ChangePasswordView from "./ChangePasswordView"

export class ChangePassword extends Component {
  static propTypes = {
    login: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    return (
      <ChangePasswordView 
        changePasswordLoading={this.props.login.changePasswordLoading}
        changePassword={this.props.actions.changePassword}
        setChangePasswordLoading={this.props.actions.setChangePasswordLoading}
      />
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    login: state.login,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangePassword);



// WEBPACK FOOTER //
// ./src/features/login/ChangePassword.js